import type { Point, Shape } from '../../../context/context';

const DEFAULT_IMPORTED_POINT_COLOR = '#3388FF';
const LAYER_POINT_COLOR_PALETTE = [
  '#1E88E5',
  '#E53935',
  '#43A047',
  '#8E24AA',
  '#FB8C00',
  '#00897B',
  '#6D4C41',
  '#3949AB',
];

function normalizeHexColour(colour: string | undefined): string {
  return (colour ?? '').trim().toUpperCase();
}

export function getLayerImportPointColour(layerId: number): string {
  const index = Math.max(0, (layerId - 1) % LAYER_POINT_COLOR_PALETTE.length);
  return LAYER_POINT_COLOR_PALETTE[index];
}

export function applyImportedPointLayerColour(shapes: Shape[], layerId: number): Shape[] {
  const layerColour = getLayerImportPointColour(layerId);
  return shapes.map((shape) => {
    if (shape.type !== 'point') {
      return shape;
    }

    const point = shape as Point;
    if (normalizeHexColour(point.colour) !== DEFAULT_IMPORTED_POINT_COLOR) {
      return point;
    }

    return {
      ...point,
      colour: layerColour,
    };
  });
}

